<template>
  <span
    :data-t-id="translateKey"
    v-html="$t(props.translateKey, props.translateOptions)"
  />
</template>
<script setup>
const props = defineProps({
  translateKey: {
    type: String,
    required: true,
  },
  translateOptions: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});
</script>
